import { NgIf } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { Dismiss } from 'flowbite';
import { Types } from 'shared-lib';
import { v4 } from 'uuid';

@Component({
  selector: 'ui-alert',
  standalone: true,
  imports: [NgIf],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
})
export class AlertComponent implements OnInit, AfterViewInit {
  title = input.required<string>();
  message = input.required<string>();
  type = input(Types.EAlert.INFO);
  editable = input(false);

  @ViewChild('alertinfo') alertInfo?: ElementRef<HTMLElement>;
  @ViewChild('alertdanger') alertDanger?: ElementRef<HTMLElement>;
  @ViewChild('alertsuccess') alertSuccess?: ElementRef<HTMLElement>;
  @ViewChild('alertwarning') alertWarning?: ElementRef<HTMLElement>;
  @ViewChild('alertdark') alertDark?: ElementRef<HTMLElement>;

  isInfo = signal<boolean>(false);
  isDanger = signal<boolean>(false);
  isSuccess = signal<boolean>(false);
  isWarning = signal<boolean>(false);
  isDark = signal<boolean>(false);
  isLight = signal<boolean>(false);

  uiId = v4();
  get UIId() {
    return `#${this.uiId}`;
  }

  constructor() {}

  ngOnInit(): void {
    this.isInfo = signal<boolean>(this.type() == Types.EAlert.INFO);
    this.isDanger = signal<boolean>(this.type() == Types.EAlert.DANGER);
    this.isSuccess = signal<boolean>(this.type() == Types.EAlert.SUCCESS);
    this.isWarning = signal<boolean>(this.type() == Types.EAlert.WARNING);
    this.isDark = signal<boolean>(this.type() == Types.EAlert.DARK);
    this.isLight = signal<boolean>(this.type() == Types.EAlert.LIGHT);
  }

  ngAfterViewInit(): void {
    let element = this.alertInfo?.nativeElement;
    if (this.isDanger()) {
      element = this.alertInfo?.nativeElement;
    }
    if (this.isSuccess()) {
      element = this.alertSuccess?.nativeElement;
    }
    if (this.isWarning()) {
      element = this.alertWarning?.nativeElement;
    }
    if (this.isDark()) {
      element = this.alertDanger?.nativeElement;
    }
    if (element) {
      const dismiss = new Dismiss(element);
      dismiss.hide();
    }
  }
}
